import { Grid, Skeleton, Typography } from "@mui/material";
import React from "react";

const UserBranchHeaderSkeleton = () => {
  return (
    <>
      <Grid
        container
        boxShadow={"0px 1px 1px rgba(0,0,0,0.16)"}
        flexDirection={"column"}
        height={"100%"}
      >
        <Grid
          item
          padding={"1rem"}
          height={"9vh"}
          justifyContent={"space-between"}
          alignItems={"center"}
          display={"flex"}
        >
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"70%"}
          >
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton
                variant="circular"
                width={50}
                height={50}
                sx={{ marginLeft: "10px" }}
              />
              <Skeleton variant="rectangular" width={50} height={20} />
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <span
                  style={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  کد ملی:
                  <Skeleton variant="rectangular" width={50} height={20} />
                </span>
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <span
                  style={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  شماره موبایل:
                  <Skeleton variant="rectangular" width={50} height={20} />
                </span>
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <span
                  style={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  تاریخ تولد:
                  <Skeleton variant="rectangular" width={50} height={20} />
                </span>
              </Typography>
            </Grid>
          </Grid>
          <Grid container width={"30%"} display={"contents"}>
            <Grid item>
              <Skeleton variant="rectangular" width={70} height={20} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default UserBranchHeaderSkeleton;
